module.exports = __webpack_public_path__ + "static/QA-32a00e4a916a3d52fe94bd471a48ad87.png";